"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerpackungMath = void 0;
/**
 * Namespace for all functions related to Verpackung calculations.
 */
class VerpackungMath {
    /**
     * Calculates Kerndurchmesser of coiled Kette.
     *
     * The trommelKerndurchmesser_mm is only used in the context of a Trommel. It has a default value
     * of "0" for Karton and Palette.
     *
     * Base calculation is:
     *  Kern = 2 * Min(R,RBR)
     */
    static calcKetteKerndurchmesser_mm(trommelKerndurchmesser_mm = 0, ketteBiegeradius_mm, ketteRBR_mm) {
        let ketteMinRadius_mm;
        if (ketteRBR_mm) {
            ketteMinRadius_mm = Math.min(ketteBiegeradius_mm, ketteRBR_mm);
        }
        else {
            ketteMinRadius_mm = ketteBiegeradius_mm;
        }
        // Bei Trommelberechnung muss für Ketten mit R, RBR < Di/2 muss mit dem Trommelkerndurchmmesser
        // Di/2 anstelle des Kettenradius gerechnet werden
        if (ketteMinRadius_mm < trommelKerndurchmesser_mm / 2) {
            return trommelKerndurchmesser_mm;
        }
        return 2 * ketteMinRadius_mm;
    }
    /**
     * Calculates number of core windings.
     *
     * Base calculation is:
     *  a = Kern / 2 / Ha
     *  b = 0,5 – (Länge / π / Ha)
     *  Windungen = -a + e^ (0,5 * logn (a² - b))
     */
    static calcKetteWindungen(ketteKernduchmesser_mm, ketteAussenhoehe_mm, ketteLaenge_mm) {
        const a = ketteKernduchmesser_mm / 2 / ketteAussenhoehe_mm;
        const b = 0.5 - ketteLaenge_mm / Math.PI / ketteAussenhoehe_mm;
        // Windungen = -a + e^ (0,5 * logn (a² - b))
        return a * -1 + Math.exp(0.5 * Math.log(a * a - b));
    }
    /**
     * Calculates Aussendurchmesser of coiled Kette on Palette.
     *
     * Base calculation is:
     *  DaKette = Kern + (Windungen * 2 * Ha) + Ha
     */
    static calcAussendurchmesserKetteForPalette_mm(ketteKernduchmesser_mm, ketteWindungen, ketteAussenhoehe_mm) {
        return ketteKernduchmesser_mm + ketteWindungen * 2 * ketteAussenhoehe_mm + ketteAussenhoehe_mm;
    }
    /**
     * Calculates Aussendurchmesser of coiled Kette on Trommel.
     */
    static calcAussendurchmesserKetteForTrommel_mm(ketteKernduchmesser_mm, ketteWindungen, ketteAussenhoehe_mm) {
        return ketteKernduchmesser_mm + ketteWindungen * 2 * ketteAussenhoehe_mm + 5 * ketteAussenhoehe_mm;
    }
}
exports.VerpackungMath = VerpackungMath;
//# sourceMappingURL=verpackung.js.map